import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetStore } from "app/actions";
import { RootState } from "app/store";
import {
  fetchConfigs,
  getConfigById,
  updateConfigs,
} from "app/thunks/configAPI";
import { Config } from "interfaces/Configs";

export interface State {
  list: Config[];
  config?: Config;
  isFetching: boolean;
  isLoading: boolean;
  isUpdating: boolean;
  error: any;
}

const initialState: State = {
  list: [],
  config: undefined,
  isFetching: false,
  isLoading: false,
  isUpdating: false,
  error: undefined,
};

export const configSlice = createSlice({
  name: "configs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
    builder.addCase(fetchConfigs.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(fetchConfigs.rejected, (state, action) => {
      state.isFetching = false;
      state.error = action.payload;
    });
    builder.addCase(
      fetchConfigs.fulfilled,
      (state, action: PayloadAction<Config[]>) => {
        state.error = undefined;
        state.isFetching = false;
        state.list = action.payload;
      },
    );
    builder.addCase(updateConfigs.pending, (state) => {
      state.isUpdating = true;
    });
    builder.addCase(updateConfigs.rejected, (state, action) => {
      state.isUpdating = false;
      state.error = action.payload;
    });
    builder.addCase(updateConfigs.fulfilled, (state) => {
      state.isUpdating = false;
      state.error = undefined;
    });
    builder.addCase(getConfigById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getConfigById.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(
      getConfigById.fulfilled,
      (state, action: PayloadAction<Config>) => {
        state.isLoading = false;
        state.config = action.payload;
      },
    );
  },
});

// ------ Selectors ------
export const getConfigs = (state: RootState) => ({
  configs: state.config.list,
  config: state.config.config,
  isLoading: state.config.isLoading,
  isFetching: state.config.isFetching,
  isUpdating: state.config.isUpdating,
});

export default configSlice.reducer;
